import axios, { AxiosRequestConfig } from "axios"

export const foundationUrl = import.meta.env.VITE_AUTH_API

const axiosConfig: AxiosRequestConfig = {
	baseURL: foundationUrl,
	headers: {
		"Content-Type": "application/json",
	},
}

export const foundationClient = axios.create(axiosConfig)
